import { ColumnDef } from "@tanstack/react-table";
import dayjs from "dayjs";
import type { IcmLineItem } from "@/icm/types";

const JobCompletedCol = (): ColumnDef<IcmLineItem> => ({
  accessorKey: "job_completed_on",
  header: "Job Completed",
  meta: { size: "140px" },
  cell: ({ getValue }) => {
    const value = getValue() as string | null;
    return value ? dayjs(value).format("MMM DD, YYYY") : "-";
  },
});

export default JobCompletedCol;
